import * as React from "react";
import classnames from "classnames";

const { Button } = require("react-bootstrap");

const styles = require("./styles.module.scss");

type Props = {
  onClick: Function;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
};

const HeaderButton: React.FC<Props> = ({ onClick, children, disabled, className }) => {
  const classes = classnames([styles.button, { [className]: !!className }]);

  return (
    <Button className={classes} bsSize="small" disabled={disabled} onClick={onClick}>
      {children}
    </Button>
  );
};

export default HeaderButton;
